interface IPropsObjectLabel {
  objectLists?: { key: string; value?: string | number; required?: boolean }[];
}

const RenderObjectLabel = (props: IPropsObjectLabel) => {
  const { objectLists } = props;
  return (
    <>
      <span className="label-text text-14 text-systemGrays02LabelSecondary">{`( `}</span>
      {objectLists?.map((obj, index) => {
        const isAllCategory = obj.key.toLowerCase() === 'categoryid' && Number(obj.value) === 0;
        const displayValue = isAllCategory ? 'ALL' : obj.value ?? '-';

        return (
          <span className="label-text text-14 text-systemGrays02LabelSecondary" key={obj.key}>
            <span>{obj.key}</span>
            {obj.required && <span className="text-colorsBrandRed01Primary">{` *`}</span>}
            <span>{`: ${displayValue}`}</span>
            {index !== objectLists.length - 1 && <span>{`, `}</span>}
          </span>
        );
      })}
      <span className="label-text text-14 text-systemGrays02LabelSecondary">{` )`}</span>
    </>
  );
};

export default RenderObjectLabel;
